// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import * as base from "./jsonProtocolBase";
/**
 * The "json.reliable.webpubsub.azure.v1" protocol
 */
export class WebPubSubJsonReliableProtocolImpl {
    constructor() {
        /**
         * True if the protocol supports reliable features
         */
        this.isReliableSubProtocol = true;
        /**
         * The name of subprotocol. Name will be used in websocket subprotocol
         */
        this.name = "json.reliable.webpubsub.azure.v1";
    }
    /**
     * Creates WebPubSubMessage objects from the specified serialized representation.
     * @param input - The serialized representation
     */
    parseMessages(input) {
        return base.parseMessages(input);
    }
    /**
     * Write WebPubSubMessage to string
     * @param message - The message to be written
     */
    writeMessage(message) {
        return base.writeMessage(message);
    }
}
//# sourceMappingURL=webPubSubJsonReliableProtocol.js.map